"use client";
import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useDayPicker } from "react-day-picker";
import { IconButton } from "../../IconButton/index.js";
import { calendarVariants } from "../Calendar/Calendar.variants.js";
function PreviousMonthButtonComponent(props) {
    const { buttonPreviousClass, buttonPreviousContainerClass } = useMemo(()=>{
        const { buttonPrevious, buttonPreviousContainer } = calendarVariants();
        return {
            buttonPreviousClass: buttonPrevious(),
            buttonPreviousContainerClass: buttonPreviousContainer()
        };
    }, []);
    const { previousMonth } = useDayPicker();
    return /*#__PURE__*/ jsx("div", {
        className: buttonPreviousContainerClass,
        children: /*#__PURE__*/ jsx(IconButton, {
            ...props,
            className: buttonPreviousClass,
            iconName: "chevron_left",
            type: "plainPrimary",
            size: "sm",
            disabled: !previousMonth
        })
    });
}
const PreviousMonthButton = /*#__PURE__*/ memo(PreviousMonthButtonComponent);
function NextMonthButtonComponent(props) {
    const { buttonNextClass, buttonNextContainerClass } = useMemo(()=>{
        const { buttonNext, buttonNextContainer } = calendarVariants();
        return {
            buttonNextClass: buttonNext(),
            buttonNextContainerClass: buttonNextContainer()
        };
    }, []);
    const { nextMonth } = useDayPicker();
    return /*#__PURE__*/ jsx("div", {
        className: buttonNextContainerClass,
        children: /*#__PURE__*/ jsx(IconButton, {
            ...props,
            className: buttonNextClass,
            iconName: "chevron_right",
            type: "plainPrimary",
            size: "sm",
            disabled: !nextMonth
        })
    });
}
const NextMonthButton = /*#__PURE__*/ memo(NextMonthButtonComponent);
export { NextMonthButton, PreviousMonthButton };
